<template>
  <div id="page" v-loading.fullscreen.lock="loadingContent && cliente.logged" element-loading-text="Carregando...">

    <Erro500 :erro="noTenant" v-if="noTenant"/>

    <div v-if="!noTenant && !$route.meta.disablePageHeader && !loadingContent && usuario.logged && usuario.logged.point">
      <EmpresaHeader/>
    </div>
    
    <div id="content"  class="pl-3 pr-3 pb-3" v-if="!noTenant && !loadingContent">
        <div class="row ">
          <div class="col-md-12" v-if="!$route.meta.disablePageHeader">
            <h3>{{$route.meta.title}}</h3>
            <b-breadcrumb :items="this.navigation"></b-breadcrumb>
          </div>

          <div class="col-md-12">
            <transition name="fade" mode="out-in">
                <router-view/>
            </transition>
          </div>
        </div>
    </div>

    <div id="footer" v-if="!noTenant && !loadingContent && cliente.logged">
      <EmpresaFooter/>
    </div>

  </div>
</template>

<script>
import Rest from "common/rest";
import EmpresaHeader from "common/menu/header.v2";
import EmpresaFooter from "common/menu/footer.v2";
import Erro500 from 'apps/template/500'

export default {
  name: "app",
  components: { EmpresaHeader, EmpresaFooter,Erro500},
  mixins: [Rest],
  data() {
    return {
      loadingContent: true,
      noTenant:null,
    };
  },

  beforeRouteUpdate(to, from, next) {
    this.validarLogin(to, from, next);
  },

  mounted() {
    this.getTenant();
  },

  created() {
    this.sub_domain = "credenciada";
    this.validarLogin();
	  this.tenant = this.$route.params.tenant;
  },

  methods: {

    getTenant: function() {

      this.noTenant = null;
      
      this.get("config").then(result => {
        
        result = result[0];

        if(result.status == 200 && result.data){
          this.cliente = result.data;
          this.getUsuario();
        }
        else{
          this.noTenant = result.msg;
        }
      });
    },

    getUsuario: function() {

      this.get('usuario/menu').then(result => {
      
        result = result[0];

        if(result.status == 200 && result.data){
          this.usuario = result.data.usuario;
          this.jwt = this.logged();
        }

        this.loadingContent = false;
      });
    },

    validarLogin(to,from,next){
      
      if(!to)to = this.$route;

      $('body').removeClass('bg-login');
      if(to.name == 'credenciada.login')
        $('body').addClass('bg-login');

      //VALIDAR AUTH
      if(to.meta && to.meta.title && to.meta.navigation){
        this.navigation = to.meta.navigation;
        this.setTitle(to.meta.title);
      }

      if(!to.matched.some(record => record.meta.requiresAuth)) {
        if(next)
          next();
      }
      else{
        if(!this.logged()){
          //this.toRoute({name:'credenciada.login'});
        }
        else{
          if(next)
            next();
        }
      }
    },

  }
};
</script>
<style lang="scss" scoped>
@import "~assets/styles/credenciada.scss";
</style>


// WEBPACK FOOTER //
// credenciada.vue?9a0f5664